import { User, UserData } from 'interfaces';

import { createIndexedDbStore } from 'lib/zustand/store';

export type AuthStoreState = {
  isLoggingOut?: boolean;
  isLoading?: boolean; // refactor into 'state' string enum: loading, loggedIn, loggedOut, error
  user: User | null;
  cleanupFunctions?: (() => void)[];
  cache?: {
    subscription: UserData['subscription'];
    entitlements: UserData['entitlements'];
    firstPdfDocument: UserData['firstPdfDocument'];
  };
};

export const useAuthStore = createIndexedDbStore<AuthStoreState>(
  () => ({
    isLoading: true,
    user: null,
    cleanupFunctions: [],
    isLoggingOut: false
  }),
  {
    storageName: 'speechify-auth-store',
    version: 2,
    partialize: state => {
      // We want to cache some properties of the user object, but not the whole thing
      let cache: AuthStoreState['cache'] = undefined;
      if (state.user) {
        cache = {
          subscription: state.user.subscription,
          entitlements: state.user.entitlements,
          firstPdfDocument: state.user.firstPdfDocument
        };
      }
      return {
        user: null,
        cache
      };
    }
  }
);
